import PropTypes from 'prop-types';
import { withApplicationContext } from '../../utils/ApplicationContext';
import InternationalBuyModal from '../SellerInfo/InternationalBuyModal/InternationalBuyModal';
import { Modal } from '../ui/Modal/Modal';
import { useInternationalShipping } from './hooks/useInternationalShipping';
import { InternationalShippingStyle } from './InternationalShipping.style';

const InternationalShipping = ({ product, appCtx }) => {
  const hookData = useInternationalShipping({ product, appCtx });

  const { internationalDeliveryText, regionCode, deviceType, modalProps, toggleState, handleToggle, shouldRender } =
    hookData;

  if (!shouldRender) {
    return null;
  }

  return (
    <div className="international_icon_wrapper">
      <span className="aeroplane-icon" />
      <p className="international-text">
        {internationalDeliveryText}
        <button type="button" className="more-info" onClick={handleToggle}>
          Conocer más
        </button>{' '}
        <i className="csicon-right" />
      </p>
      <Modal
        content={(actions) => <InternationalBuyModal actions={actions} deviceType={deviceType} tenant={regionCode} />}
        toggleState={toggleState}
        {...modalProps}
      />
      <style jsx>{InternationalShippingStyle}</style>
    </div>
  );
};

InternationalShipping.propTypes = {
  product: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
};

export default withApplicationContext(InternationalShipping);
